import { NavLink } from 'react-router-dom';

// เส้น SVG เรียบๆ (ไม่ใช้อีโมจิ) — ให้สีตาม currentColor เดินตาม CSS .bottom-nav-item.active เอง
const icons = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11l9-8 9 8" />
      <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
    </svg>
  ),
  tables: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1.5" />
    </svg>
  ),
  kitchen: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  ),
  checkout: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
    </svg>
  ),
  menu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  ),
};

// จุดที่ใช้บ่อยที่สุดในหน้างานประจำวัน (ตรงกับกลุ่ม "การขายประจำวัน" ที่เปิดค้างไว้เป็นค่าเริ่มต้น
// ใน SIDEBAR_GROUPS อยู่แล้ว) ส่วนหน้าที่เหลือทั้งหมด (รายงาน/จัดการร้าน/ตั้งค่า) ยังเข้าถึงได้ผ่าน
// ปุ่ม "เมนู" ที่เปิด sidebar drawer เดิม ไม่ได้ตัดอะไรออกจากระบบเดิม แค่เพิ่มทางลัด
const TABS = [
  { to: '/', end: true, label: 'หน้าแรก', icon: icons.home },
  { to: '/tables', label: 'จัดการโต๊ะ', icon: icons.tables },
  { to: '/kitchen', label: 'จอครัว', icon: icons.kitchen },
  { to: '/checkout', label: 'ชำระเงิน', icon: icons.checkout },
];

export default function BottomNav({ onOpenMenu }) {
  return (
    <nav className="bottom-nav">
      {TABS.map(tab => (
        <NavLink key={tab.to} to={tab.to} end={tab.end} className="bottom-nav-item">
          <span className="bottom-nav-icon">{tab.icon}</span>
          <span className="bottom-nav-label">{tab.label}</span>
        </NavLink>
      ))}
      <button type="button" className="bottom-nav-item" onClick={onOpenMenu}>
        <span className="bottom-nav-icon">{icons.menu}</span>
        <span className="bottom-nav-label">เมนู</span>
      </button>
    </nav>
  );
}
